__turbopack_context__.v({
  "chevron-down-icon": "mochi-select-module-scss-module__rbUPFq__chevron-down-icon",
  "container": "mochi-select-module-scss-module__rbUPFq__container",
  "dark-mode": "mochi-select-module-scss-module__rbUPFq__dark-mode",
  "empty": "mochi-select-module-scss-module__rbUPFq__empty",
  "error-message": "mochi-select-module-scss-module__rbUPFq__error-message",
  "invalid": "mochi-select-module-scss-module__rbUPFq__invalid",
  "normal": "mochi-select-module-scss-module__rbUPFq__normal",
  "round": "mochi-select-module-scss-module__rbUPFq__round",
  "select": "mochi-select-module-scss-module__rbUPFq__select",
  "select-container": "mochi-select-module-scss-module__rbUPFq__select-container",
  "with-placeholder": "mochi-select-module-scss-module__rbUPFq__with-placeholder",
});
